export const CONFIRMED_GET_COMPANIES = "[Post Action] Confirmed Get Companies";
export const GET_COMPANIES_FAILED_ACTION = "[Get Action] Get Company failed";
export const GET_COMPANIES_CONTACT_FAILED_ACTION = "[Get Action] Get Company contacts failed";
export const CONFIRMED_GET_COMPANIES_CONTACT = "[Get Action] Confirmed Get Companies";
export const ADD_COMPANY_SUCCESS = "[Post Action] Add Company success";
export const ADD_COMPANY_FAILED = "[Post Action] Add Company failed";
export const ADD_COMPANY_CONTACT_SUCCESS = "[Post Action] Add Company Contact success";
export const ADD_COMPANY_CONTACT_FAILED = "[Post Action] Add Company Contact failed";
export const UPDATE_COMPANY_FAILED = "[Put Action] Update Company failed";
export const UPDATE_COMPANY_SUCCESS = "[Put Action] Update Company success";
export const CONFIRMED_GET_COMPANY = "[Get Action] Get Single Company success";
